import { useEffect, useState } from 'react'
import { SelectOptionWithDarkMode } from '../../types/DropDownTypes'
import { IconSquare, IconSquareCheckFilled } from '@tabler/icons-react'

interface IRadioButtonGroupProps {
  options: SelectOptionWithDarkMode[]
  value: SelectOptionWithDarkMode[]
  onChangeHandler?: (options: SelectOptionWithDarkMode[], value?: SelectOptionWithDarkMode) => void
}

export const RadioButtonGroup = ({ options, value, onChangeHandler }: IRadioButtonGroupProps) => {
  const [currentValue, setCurrentValue] = useState(value)

  useEffect(() => {
    setCurrentValue(value)
  }, [value])

  const handleOnChange = (checked: boolean, option: SelectOptionWithDarkMode) => {
    const updatedValues = checked
      ? [...(currentValue || []), option]
      : currentValue?.filter((o) => o.value !== option.value) || []
    if (onChangeHandler) {
      onChangeHandler(updatedValues, checked ? option : undefined)
    }
  }

  const isOptionSelected = (option: SelectOptionWithDarkMode) => {
    return currentValue?.some((o) => o.value === option.value)
  }

  return (
    <div className="flex flex-col gap-2">
      {options.map((option) => (
        <div
          key={option.value}
          className={`flex items-center gap-3 p-2 rounded border border-mainBorder dark:bg-inputBackground ${option.disabled ? 'bg-contentBackground cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={() => {
            if (option.disabled) return
            const isSelected = isOptionSelected(option)
            handleOnChange(!isSelected, option)
          }}
        >
          {isOptionSelected(option) ? (
            <IconSquareCheckFilled className={`${option.disabled ? 'text-neutral-8 dark:text-neutral-11' : 'text-PurpleBlue-9'}`} />
          ) : (
            <IconSquare className={`w-6 h-6 text-mainBorder ${option.disabled ? '' : 'dark:text-neutral-8'}`} />
          )}
          <div className="flex flex-col leading-tight">
            <p className="font-medium text-sm">{option.label}</p>
            <span className="text-xs">{option.description}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default RadioButtonGroup
